module.exports = __webpack_public_path__ + "static/media/InvitationMaker-2.9560fbe3.webp";